import {fieldValue} from "../common/NamaCommon";
import * as Formats from "../constants/Formats";
import {DateTimeFieldWidget} from "../widgets/DateTimeFieldWidget";

export function dateTimeTemplate(fieldId, trimmedFieldId) {

    return (dataItem) => {
        let value = fieldValue(dataItem, trimmedFieldId);
        if (!value)
            return "";
        return kendo.toString(kendo.parseDate(value, Formats.DATE_SERVER_FORMAT), "dd-MM-yyyy hh:mm tt");
    }
}

export function dateTimeColumnEditor(fieldMetadata, trimmedFieldId, grid) {
    return (container, options) => {
        let widget = new DateTimeFieldWidget({owner: grid, fieldMetadata, cellOptions: options});
        widget.inputName = options.field;
        grid.afterAddingToGridAction(widget, options, trimmedFieldId, container);
    }
}